<template>
  <div class="is-padding-right-on-btn-actions is-padding-left-on-btn-actions">
    <tabs
      v-if="programTabLinks"
      :links="programTabLinks"
      :level="1"
      :is-fullwidth="true"
      class="is-border-bottom is-margin-bottom"></tabs>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-padd-left-on-act="false"
      :has-padd-right-on-act="false"
      :has-left-col-small="$route.name === 'ProgramDistributeurInfos'"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div
          class="has-background-white is-border"
          id="topView">
          <div
            v-if="program.promoteur.picture"
            class="is-padding">
            <figure class="">
              <!-- <img :src="program.promoteur.picture.path"> -->
              <img
                :src="program.promoteur.picture.cloudinary_id | cloudinary({width: 'auto', height: 80, width: 390, crop: 'limit', quality: '100', dpr: '2'})"
                class="is-block"
                style="max-height:80px">
            </figure>
          </div>
          <div class="columns is-gapless">
            <span class="column is-12 is-padding-left">
              <a
                @click="openModalTicket"
                class="is-underline is-size-6">Contactez l’équipe support du {{ nameToUse }}</a>
            </span>
          </div>
          <div
            v-if="!programRemunerationLoading"
            class="columns is-gapless is-marginless-bottom">
            <span class="column is-12 is-padding-left is-padding-top-small is-padding-bottom-small has-text-white has-background-dark is-size-4">
              <span v-if="(programRemuneration && isDistributeur) || isDistributeur && (currentUser.active_all_contact || isSeller)">
                Commission : {{ programRemuneration && programRemuneration.remuneration ? programRemuneration.remuneration + ' % HT' : '--' }}
              </span>
              <span v-else>
                Comm {{ nameToUse }} : {{ program.remuneration ? program.remuneration + ' % HT' : '--' }}
              </span>
            </span>
          </div>
          <div
            v-if="canSeeGfa && !program.use_tranche"
            class="is-padding">
            <div class="is-margin-bottom-xsmall">
              <span class="title is-5">OBJECTIF GFA* </span>
              <span
                class="is-padding-left-xsmall"
                v-helper.bottom="'37up8jyDO5c6qQWzcHkkKZ'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
            <program-progress-bar
              class=" is-margin-bottom-xsmall"
              :classes="'is-success has-glueValue is-xxlarge is-radiusless'"
              :value="program.lot_resume.gfa_percentage"
              :max="100"
              :value-human="`${program.lot_resume.gfa_percentage}%`"
              :display-value="true"></program-progress-bar>
            <div class="is-size-6 has-text-primary is-italic">
              *Réservation(s) au {{ today | dtFormat('DD/MM/YYYY') }}
            </div>
          </div>
          <div
            class="columns has-background-annonce is-vcentered is-gapless is-padding-left"
            v-if="!program.is_optionable">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
              <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
            </div>
            <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-white is-italic is-size-7 has-text-weight-bold">
                <span>Non optionnable</span>
              </div>
            </div>
          </div>
          <div class="columns is-gapless is-marginless-bottom is-multiline">
            <div class="column is-12 is-padding is-border-bottom is-border-top is-border--dashed">
              <div class="">
                <div
                  v-if="program.progress_step || program.tags.length"
                  class="is-margin-bottom-small">
                  <div class="tags">
                    <span
                      v-if="program.progress_step"
                      class="tag is-info">{{ program.progress_step | programStepProgressLabel }}</span>
                    <span
                      v-for="tag in program.tags"
                      :key="tag"
                      class="tag is-annonce">{{ tag }}</span>
                  </div>
                </div>
              </div>
              <div
                class="has-text-grey is-size-6"
                style="text-transform: capitalize">
                {{ nameToUse }}
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                <div v-if="program.address && program.address.zip_code">
                  {{ program.address.line1 }}<br>
                  {{ program.address.zip_code }} {{ program.address.city }} <i>{{ program.address.country }}</i>
                </div>
                <div v-else-if="program.address && program.address.latitude && program.address.longitude">
                  Coordonnées GPS<br>
                  <small>{{ program.address.latitude }}, {{ program.address.longitude }}</small>
                </div>
                <div v-else>
                  NC
                </div>
              </div>
              <router-link
                :to="{name: 'ProgramMapTab', params: {id: program.pk}}"
                class="is-linkTextPicto is-size-6 is-padding-top has-text-dark">
                <span><i>Afficher sur la carte</i></span>
                <span class="icon"><i class="fal fa-long-arrow-right"></i></span>
              </router-link>
            </div>
          </div>
          <div class="columns is-gapless is-multiline is-marginless">
            <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Dispositif(s)
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4 is-break-word">
                {{ taxDispositifs }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Zone
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                {{ program.tax_zone || '--' |taxZonesLabel }}
              </div>
            </div>
            <div
              v-if="program.is_amenagement"
              class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Type d'opération
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                {{ program.operation_type || '--' | operationTypeLabel }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Actabilité
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                {{ program.date_actabilite || '--' |
                  prettyTrimestre }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Livraison
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                {{ program.date_livraison || '--' |
                  prettyTrimestre }}
              </div>
            </div>
            <div
              class="column is-6 is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall"
              v-if="program.is_amenagement">
              <div class="has-text-grey is-size-6">
                Date butoir de dépôt PC
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-4">
                {{ deadline_date || '--' }}
              </div>
            </div>
          </div>
          <div v-if="tranches && tranches.length && program.use_tranche">
            <div
              v-for="(tranche, i) in tranches"
              :key="i">
              <div class="is-flex-between is-padding-left-small is-padding-right-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border--dashed">
                <span class="is-uppercase has-text-weight-medium">{{ tranche.name }}</span>
                <i
                  v-if="!openTranchesDetail.includes(i)"
                  @click="toggleTranchesDetail(i)"
                  class="is-size-6 is-underline has-cursor-pointer">Voir le détail</i>
                <i
                  v-else
                  @click="toggleTranchesDetail(i)"
                  class="is-size-6 is-underline has-cursor-pointer">Masquer le détail</i>
              </div>
              <div
                v-if="openTranchesDetail.includes(i)"
                class="is-flex-between is-padding-left-small is-padding-right-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border--dashed has-background-white-ter">
                <span
                  v-if="program.program_params.show_gfa"
                  class="is-size-6 has-text-grey">GFA : <span class="is-size-5 has-text-black">{{ tranche.gfa_percentage }}%</span></span>
                <span class="is-size-6 has-text-grey">Actabilité : <span class="is-size-5 has-text-black">{{ tranche.date_actabilite || '--' | prettyTrimestre }}</span></span>
                <span class="is-size-6 has-text-grey">Livraison : <span class="is-size-5 has-text-black">{{ tranche.date_livraison || '--' | prettyTrimestre }}</span></span>
              </div>
            </div>
          </div>
          <div class="columns is-gapless">
            <div
              v-if="program.certifications && program.certifications.length > 0"
              class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom is-border--dashed">
              <div class="is-flex is-wrap-flex">
                <span
                  v-for="(certification, index) in program.certifications"
                  :key="index">
                  <img
                    class="img--certification is-padding-right-xsmall"
                    :src="certification | programCertificationImage"
                    :alt="certification | programCertificationLabel">
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <router-view
        :key="$route.name"
        :program="program"
        :program-lots="lots"
        :program-autres="autres"
        :program-contacts="program.contacts"
        :loading="loading"
        :no-more-result="noMoreResult"
        :no-parking-more-result="noParkingMoreResult"
        :no-autre-more-result="noMoreResult"
        :program-parkings="parkings"
        :program-lots-count="programLotsCount"
        :program-parkings-count="programParkingsCount"
        :program-autres-count="programAutresCount"
        :lot-pages="lotPages"
        :parking-pages="parkingPages"
        :autre-pages="autrePages"
        :current-lot-page="currentLotPage"
        :current-parking-page="currentParkingPage"
        :current-autre-page="currentAutrePage"
        @getProgramLots="getProgramLots"
        @getProgramParkings="getProgramParkings"
        @getProgramAutres="getProgramAutres"
        @deleteAccess="deleteAccess"
        @openModalTicket="openModalTicket"></router-view>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import ProgramProgressBar from './ProgramRightPanel/ProgramProgressBar'
import moment from 'moment'

export default {
  name: 'ProgramDistributeurVue',
  components: { ProgramProgressBar },
  mixins: [DefaultValues],
  props: {
    program: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deadline_date: this.program.construction_data.deadline_pc_date,
      loading: false,
      noMoreResult: false,
      noParkingMoreResult: false,
      noAutreMoreResult: false,
      programRemunerationLoading: false,
      programRemuneration: null,
      lots: [],
      parkings: [],
      autres: [],
      lotsTotal: 0,
      currentLotPage: 1,
      currentParkingPage: 1,
      currentAutrePage: 1,
      lotPages: null,
      parkingPages: null,
      autrePages: null,
      programLotsCount: 0,
      programParkingsCount: 0,
      programAutresCount: 0,
      tranches: [],
      openTranchesDetail: []
    }
  },
  computed: {
    ...mapGetters(['isDistributeur', 'isPromoteur', 'isSeller']),
    ...mapState(['currentUser']),
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    },
    canSeeGfa () {
      if (this.isExterne && !this.program.program_params.show_gfa) {
        return false
      } else {
        return true
      }
    },
    /**
       * today
       * @returns {date}
       */
    today () {
      return moment()
    },
    isExterne () {
      if (this.currentUser && this.program) {
        return this.currentUser.account.pk !== this.program.promoteur.pk
      } else {
        return false
      }
    },
    programView () {
      return this.$route.name
    },
    programPk () {
      return this.$route.params.id
    },
    programTabLinks () {
      let tabs = []
      tabs.push({ link: 'ProgramDistributeurInfos', label: 'FICHE ' + this.nameToUse.toUpperCase() })
      tabs.push({ link: 'ProgramLots', label: `TABLEAU DES LOTS (${this.lotsTotal} DISPONIBLES)` })
      tabs.push({ link: 'ProgramMapTab', label: `LOCALISATION` })
      tabs.push({ link: 'ProgramContacts', label: `CONTACTS` })
      tabs.push({ link: 'ProgramStats', label: 'ACTIVITÉ COMMERCIALE' })
      return tabs
    },
    taxDispositifs () {
      return this.program.tax_dispositifs.map(x => (this.taxDispositifsData[x]) ? this.taxDispositifsData[x].label : x).join(', ')
    }
  },
  created () {
    if (this.deadline_date != null) {
      this.deadline_date = moment(this.deadline_date).format('DD-MM-YYYY')
    }
    if (!this.programTabLinks.map(x => x.link).includes(this.programView)) {
      this.$router.replace({ name: 'ProgramDistributeurInfos' }).catch(() => {})
    }
    this.getProgramLotsCount()
    this.getProgramLots()
    this.getProgramTranches()
    this.getProgramParkings()
    this.getProgramAutres()
    this.getProgramRemuneration()
    // if (this.isPromoteur && this.isAdmin) {
    //   this.getProgramRemuneration()
    // }
  },
  methods: {
    async getProgramRemuneration () {
      this.programRemunerationLoading = true
      let params = { program: this.programPk }
      try {
        const { data } = await this.$api.get(this.$resources.ACCESS, params)
        let remuneration = data.items && data.items.length ? data.items[0] : null
        this.programRemuneration = remuneration
      } catch (e) {
        console.log(e)
      }
      if (this.programRemuneration == null) {
        try {
          let { data } = await this.$api.get(this.$resources.MANDAT, params)
          let remuneration = data.items && data.items.length ? data.items[0] : null
          this.programRemuneration = remuneration
        } catch (e) {
          console.log(e)
        }
      }
      this.programRemunerationLoading = false
    },
    openModalTicket () {
      const formatedReferents = this.program.referents.map(x => {
        return {
          ...x,
          picture: x.picture[0]
        }
      })
      let params = {
        defaultSubject: 'program_information',
        defaultTitle: this.nameToUse + ' ' + this.program.name,
        promoteur: this.program.promoteur.pk,
        referents: formatedReferents || null
      }
      this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
    },
    changeViewProgram (link) {
      this.$router.replace({ name: link }).catch(() => {})
    },
    async deleteAccess (pk) {
      let value = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au ' + this.nameToUse + ', cette action entrainera également l\'annulation de ses options sur ce ' + this.nameToUse + '.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCESS, pk)
          this.$toasted.global.success('Mandat supprimé')
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    },
    async getProgramLotsCount () {
      let params = {
        program: this.programPk,
        per_page: 1,
        status: ['available', 'optioned']
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lotsTotal = data.count
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramLots (filters = {}, page = 1) {
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['lot', 'flat', 'house', 'field', 'commercial', 'office', 'bedroom'],
        ...filters
      }
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lots = data.items
        this.programLotsCount = data.count
        this.lotPages = data.pages
        this.currentLotPage = data.page
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la récupération des lots !')
      } finally {
        this.loading = false
      }
    },
    async getProgramParkings (filters = {}, page = 1) {
      this.noParkingMoreResult = false
      this.loading = true
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['parking'],
        ...filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.parkings = data.items
        this.programParkingsCount = data.count
        this.parkingPages = data.pages
        this.currentParkingPage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async getProgramAutres (filters = {}, page = 1) {
      this.noAutreMoreResult = false
      this.loading = true
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['garden', 'annexe'],
        ...filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.autres = data.items
        this.programAutresCount = data.count
        this.autrePages = data.pages
        this.currentAutrePage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async getProgramTranches () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_TRANCHE(this.programPk))
        this.tranches = data.items
      } catch (error) {
        console.error(error)
      }
    },
    toggleTranchesDetail (index) {
      if (this.openTranchesDetail.findIndex(x => x === index) === -1) this.openTranchesDetail.push(index)
      else this.openTranchesDetail.splice(this.openTranchesDetail.findIndex(x => x === index), 1)
    }
  }
}
</script>
